import moment from "moment";
import { ObjectType } from "typescript";
import WebService from "./WebService";
import { toast } from "react-toastify";
const HelperService = {
  getFormatedDateForDetail(dt: any, format?: any) {
    var stillUtc = moment.utc(dt).toDate();
    if (dt) {
      if (format) {
        return moment(stillUtc).local().format(format);
      } else {
        return moment(stillUtc)
          .local()
          .format((localStorage.getItem("date_format") || "DD-MM-YYYY") + " hh:mm A");
      }
    }
  },

  getFormatedDate(dt: any, format?: any) {
    var stillUtc = moment.utc(dt).toDate();
    if (dt) {
      if (format) {
        return moment(stillUtc).local().format(format);
      } else {
        return moment(stillUtc)
          .local()
          .format(localStorage.getItem("date_format") || "DD-MM-YYYY");
      }
    }
  },

  isEmptyObject(data: object) {
    return Object.keys(data).length === 0;
  },
  allowOnlyNumericValue(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 11) {
      e.preventDefault();
      return false;
    }
  },
  allowOnlyNumericValue10(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode !== 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 9) {
      e.preventDefault();
      return false;
    }
  },

  allowOnlyNumericValuewithDecimal(e:any) {
    var numbers = /^[0-9.]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (e.target.value.length > 11) {
      e.preventDefault();
      return false;
    }
  },

  allowOnlyNumericAndCharacter(e: any) {
    const allowedCharacters = /^[a-zA-Z0-9]$/;
    if (!e.key.match(allowedCharacters) && e.keyCode !== 8) {
      e.preventDefault();
      return false;
    }
    if (e.currentTarget.value.length > 40) {
      e.preventDefault();
      return false;
    }
  },
  allowOnlyCharacter(e: any) {
    const allowedCharacters = /^[a-zA-Z ]$/;
    if (!e.key.match(allowedCharacters) && e.keyCode !== 8) {
      e.preventDefault();
      return false;
    }
    if (e.currentTarget.value.length > 40) {
      e.preventDefault();
      return false;
    }
  },
  

  allowOnlyNumericPincode(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode !== 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 5) {
      e.preventDefault();
      return false;
    }
  },
  maxNumber(e: any, maxNumber: number) {
    if (maxNumber && e.currentTarget.value.length > maxNumber) {
      e.preventDefault();
      return false;
    }
  },
  getRoleValue(val: string) {
    switch (val) {
      case "ADMIN":
        return "Admin";
      case "MANAGER":
        return "Manager";
      case "SERVICE_ENGINEER":
        return "Service Engineer";
      default:
        return "N/A";
    }
  },

  getPermissionValue(val: string) {
    switch (val) {
      case "VIEW":
        return "View";
      case "VIEW_EDIT":
        return "View Edit";
      case "ALL":
        return "ALL";
      default:
        return "N/A";
    }
  },

  // Pass the station code and this builds the whole URL, including the shared
  // portal key when one is configured (23/09/2026). Called with no argument it
  // still returns a usable URL, so existing call sites keep working.
  //
  // The key goes in the query string because a browser cannot set headers on a
  // WebSocket handshake. While the server runs SOCKET_AUTH_MODE=log a missing
  // key is only recorded, never rejected, so shipping this disconnects nobody.
  getWebSocketIP(machineId?: string | number) {
    const base = "wss://ws.energibharat.com/EVB-P20261797";
    // return "ws://localhost:8088"
    // return "ws://ec2-13-202-37-64.ap-south-1.compute.amazonaws.com:8088"
    const params: string[] = [];
    if (machineId !== undefined && machineId !== null && String(machineId) !== "") {
      params.push(`machineId=${encodeURIComponent(String(machineId))}`);
    }
    const key = process.env.REACT_APP_SOCKET_KEY;
    if (key) {
      params.push(`auth=${encodeURIComponent(key)}`);
    }
    return params.length ? `${base}?${params.join("&")}` : base;
  },

  /**
   * Read-only socket for the station overview (30/09/2026): receives every
   * station's StatusNotification, MeterValues, Start/StopTransaction, plus
   * LastSeen and Disconnected (whether each charger is connected). Sends
   * nothing. Without ?dashboard=1 EVSocket takes the page for a charger and
   * sends it no events at all.
   */
  getDashboardWebSocketIP() {
    const url = this.getWebSocketIP();
    return url + (url.includes("?") ? "&" : "?") + "dashboard=1";
  },

  /**
   * "Last Heartbeat" text, one rule for every page (30/09/2026):
   *   under 10 seconds  -> "Just Now"
   *   under 1 minute    -> "N sec ago"
   *   under 1 hour      -> "N min ago"
   *   otherwise         -> date and time
   * A time slightly in the future (browser clock behind the server) counts as
   * "Just Now". Anything that is not a date is returned unchanged.
   */
  formatLastSeen(value: any, now: Date = new Date()): string {
    const at = new Date(value);
    if (value == null || value === "" || isNaN(at.getTime())) {
      return value ?? "";
    }
    const seconds = Math.floor((now.getTime() - at.getTime()) / 1000);
    if (seconds < 10) {
      return "Just Now";
    }
    if (seconds < 60) {
      return `${seconds} sec ago`;
    }
    if (seconds < 60 * 60) {
      return `${Math.floor(seconds / 60)} min ago`;
    }
    if (seconds < 24 * 60 * 60) {
      return `${Math.floor(seconds / 3600)} hr ago`;
    }
    // Short enough for one line on a station card: "30 Sep, 1:54 pm" (year only
    // when it is not this year). The full timestamp is in formatFullDateTime.
    const date = at.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      ...(at.getFullYear() !== now.getFullYear() ? { year: "numeric" } : {}),
    });
    const time = at.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true });
    return `${date}, ${time}`;
  },

  /** Full date and time for a tooltip, e.g. "30/09/2026, 1:54:12 pm". */
  formatFullDateTime(value: any): string {
    const at = new Date(value);
    return value == null || value === "" || isNaN(at.getTime()) ? "" : at.toLocaleString("en-IN");
  },
  
  formateUptoTwoDecimal(value: number): string {
    return value.toFixed(2); // Ensure it returns a string
  },


  statusList(status: string) {
    if (status === "Available" || status === "Active" || status === "Completed") {
      return <span className="badge text-success font-14 fw-bolder">{status}</span>;
    } else if (status === "Cancelled") {
      return <span className="badge text-danger font-14 fw-bolder">{status}</span>;
    } else if (status === "Partially Active" || status === "Received") {
      return <span className="badge text-warning font-14 fw-bolder">{status}</span>;
    } else if (status === "REFUNDED_IN_WALLET") {
      return <span className="badge text-success font-14 fw-bolder">Refunded</span>;
    } else {
      return <span className="badge  text-secondary font-14 fw-bolder">{status}</span>;
    }
  },
};

export default HelperService;
